import { useAnalytics, withAnalyticsContext } from '@melio/platform-analytics';
import { useMelioIntl } from '@melio/platform-i18n';
import { useEffect } from 'react';

import { NewSinglePaymentStepLayout } from '../../../NewSinglePaymentStepLayout';
import { BusinessSearchForm, BusinessSearchFormProps } from './components/BusinessSearchForm';

type SearchBusinessScreenProps = BusinessSearchFormProps & {
  onClose: VoidFunction;
};

export const SearchBusinessScreen = withAnalyticsContext<SearchBusinessScreenProps>(
  ({ setAnalyticsProperties, onSelectOption, onCreateOption, onClearField, onClose, ...props }) => {
    const { formatMessage } = useMelioIntl();

    setAnalyticsProperties({
      PageName: 'search-vendor',
      Intent: 'add-a-vendor',
    });

    const { track } = useAnalytics();

    useEffect(() => {
      track('Vendor', 'View');
    }, [track]);

    return (
      <NewSinglePaymentStepLayout
        data-component="AddVendorActivity.SearchBusinessScreen"
        data-testid="add-vendor-activity-search-business-screen"
        headerContent={
          <NewSinglePaymentStepLayout.Header>
            <NewSinglePaymentStepLayout.CloseButton onClick={onClose} />
          </NewSinglePaymentStepLayout.Header>
        }
        {...props}
      >
        <NewSinglePaymentStepLayout.Title>
          {formatMessage('activities.addVendor.screens.searchBusiness.title')}
        </NewSinglePaymentStepLayout.Title>
        <NewSinglePaymentStepLayout.Description>
          {formatMessage('activities.addVendor.searchAndAddVendorDetails.description')}
        </NewSinglePaymentStepLayout.Description>
        <NewSinglePaymentStepLayout.Content>
          <BusinessSearchForm
            onSelectOption={onSelectOption}
            onCreateOption={onCreateOption}
            onClearField={onClearField}
          />
        </NewSinglePaymentStepLayout.Content>
      </NewSinglePaymentStepLayout>
    );
  }
);

SearchBusinessScreen.displayName = 'AddVendorActivity.SearchBusinessScreen';
